import PageShell from "../components/PageShell";
import { viewsFor } from "../content/views";
import seoPages from "../content/seo-pages.json";

const views = viewsFor("how-we-work");
const seo = seoPages["/how-we-work"];

export default function HowWeWork() {
  return (
    <PageShell
      title={seo.title}
      description={seo.description}
      bodyClass=""
      dataFrame={null}
      views={views}
    />
  );
}
